export default class LoginContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Login";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    if(!model) model = app;
    
    app.populate(pageId, model);
    app.swapPage(pageId);
  }

  loginGuest() {
    const app = this.app;

    let name = app.userdata.name;
    let email = Math.floor(Math.random() * 1000000000000) + "@fake.com";
    let avatar = app.userdata.avatar;

    //set email to prevent needing to login everytime the app opens
    if (!app.userdata.name) app.userdata.name = "Player" + Math.floor(Math.random() * 100000);
    if (!app.userdata.email) app.userdata.email = email;
    if (!app.userdata.coins) app.userdata.coins = 0;

    //Get Id in the the background if the user does not have one
    if (!app.userdata.id) {
      let userdata = {
        name: name,
        email: email,
        password: "",
        avatar: avatar,
        emailSubscribe: false
      };
      app.accountJD.Register(userdata)
        .then((data) => {
          if (!data || !data.id) return;
          if (data.id) app.userdata.id = data.id;
          if (data.name) app.userdata.name = data.name;
          if (data.email) app.userdata.email = data.email;
          if (data.facebookId) app.userdata.facebookId = data.facebookId;
          if (data.avatar) app.userdata.avatar = data.avatar;
          if (data.emailSubscribe) app.userdata.emailSubscribe = data.emailSubscribe;
          app.save();
        });
    }
    //no data needed from server, just start the app
    app.dataLoaded();
  }
}
